import { render } from "./EntitySelectorTransportador.vue?vue&type=template&id=b5532f0a"
import script from "./EntitySelectorTransportador.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script